import useModuleState from './useModuleState';

export const useFeatureFlags = () => {
  return useModuleState('use-feature-flag', { loading: true });
};

export default useFeatureFlags;
